import { gql, useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { IHookCallbacks } from 'src/hooks/common.hooks.interfaces';

import { GET_PROCESS_TASKS_FOR_TABLE } from './get-process-tasks.hook';
import { NOTIFICATION_TYPE, showNotification } from '@thinknet-gmbh/platform-common-ui';


const CREATE_PROCESS_TASK = gql`
  mutation createTask($payload: CreateProcessTaskInput!) {
    createProcessTask(payload: $payload) {
      _id
    }
  }
`;

export const useCreateProcessTask = ({ onSuccess }: IHookCallbacks) => {
  const { t } = useTranslation('processBuilder');
  const [createProcessTask, {loading}] = useMutation(CREATE_PROCESS_TASK, {
    onCompleted: data => {
      if (data?.createProcessTask?._id) {
        showNotification({
          isIcon: false,
          type: NOTIFICATION_TYPE.success,
          message: t('tasks.notifications.created'),
        });
        if (onSuccess) {
          onSuccess();
        }
      }
    },
    refetchQueries: [GET_PROCESS_TASKS_FOR_TABLE],
  });

  return { createProcessTask, loading };
};
